import {
  LanguagesResponse,
  ProfileCvStatusResponse,
  ProfileLanguageResponse,
  ProfileResponse,
} from "../types/api";
import axiosInstance from "../utils/axios";

export const getProfile = async (
  language: string = "en"
): Promise<ProfileResponse> => {
  try {
    const response = await axiosInstance.get<ProfileResponse>(
      `/api/profiles/?lang=${language}`
    );

    if (response.data.status !== "success") {
      throw new Error("Failed to fetch profile");
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to fetch profile");
  }
};

export const getProfileCvStatus = async (
  cvId: number
): Promise<ProfileCvStatusResponse> => {
  try {
    const response = await axiosInstance.get<ProfileCvStatusResponse>(
      `/api/profiles/cvs/${cvId}/status/`
    );

    if (response.data.status !== "success") {
      throw new Error("Failed to fetch profile");
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to fetch profile");
  }
};

export const getProfileLanguages = async (): Promise<LanguagesResponse> => {
  try {
    const response = await axiosInstance.get<LanguagesResponse>(
      "/api/profiles/available-languages/"
    );

    if (response.data.status !== "success") {
      throw new Error("Failed to fetch language");
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching languages:", error);
    throw new Error("Failed to fetch languages");
  }
};

export const getUserProfileLanguage = async (): Promise<LanguagesResponse> => {
  try {
    const response = await axiosInstance.get<ProfileLanguageResponse>(
      "/api/profiles/display-language/"
    );

    if (response.data.status !== "success") {
      throw new Error("Failed to fetch profile");
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to fetch profile");
  }
};

export const setProfileLanguage = async (language: string) => {
  try {
    const response = await axiosInstance.post(
      "/api/profiles/display-language/",
      {
        language,
      }
    );

    if (response.data.status !== "success") {
      throw new Error("Failed to fetch profile");
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to fetch profile");
  }
};
